import React from "react";
import ReactDOM from "react-dom/client";

import config from "@app/config";
import { CartDrawer } from "@app/scripts/react-cart/components/CartDrawer";
import { CartMain } from "@app/scripts/react-cart/components/CartMain";

import type { GiftProduct } from "@app/scripts/types";
import { addToCart } from "../utils";

const getGiftProduct: () => GiftProduct = () => {
  try {
    const giftProduct = JSON.parse(document.querySelector("[data-giftproduct]").innerHTML);

    if (giftProduct) return giftProduct;
  } catch (error) {
    console.error(error);
  }
  return null;
};

const CartDrawerElem = class extends HTMLElement {
  static observedAttributes = ["heading", "you-may-also-like-heading"];

  connectedCallback() {
    const freeShipping = document.querySelector("[data-freeshipping]")?.getAttribute("data-freeshipping");
    const lowStockThreshold = document
      .querySelector("[data-low-stock-threshold]")
      ?.getAttribute("data-low-stock-threshold");
    const youMayAlsoLikeCollection = document
      .querySelector("[data-you-may-also-like-collection")
      ?.getAttribute("data-you-may-also-like-collection");

    let props: any = {
      config,
      heading: this.getAttribute("heading"),
      freeShipping: freeShipping ? parseFloat(freeShipping) : null,
      giftProduct: getGiftProduct(),
      youMayAlsoLikeHeading: this.getAttribute("you-may-also-like-heading"),
      lowStockThreshold: Number(lowStockThreshold),
      ...(youMayAlsoLikeCollection && {
        youMayAlsoLikeCollection: JSON.parse(youMayAlsoLikeCollection),
      }),
      youMayAlsoLikeProductsToShow: this.getAttribute("you-may-also-like-to-show"),
    };

    const root = ReactDOM.createRoot(this);
    root.render(<CartDrawer {...props} />);
  }
};

customElements.define("cart-drawer", CartDrawerElem);

const CartMainElem = class extends HTMLElement {
  connectedCallback() {
    const freeShipping = document.querySelector("[data-freeshipping]")?.getAttribute("data-freeshipping");
    const lowStockThreshold = document
      .querySelector("[data-low-stock-threshold]")
      ?.getAttribute("data-low-stock-threshold");

    let props: any = {
      config,
      freeShipping: freeShipping ? parseFloat(freeShipping) : null,
      giftProduct: getGiftProduct(),
      lowStockThreshold: Number(lowStockThreshold),
    };

    try {
      const ac = JSON.parse(this.querySelector("[data-additionalcheckout]")?.innerHTML);
      props.additionalCheckout = ac?.html;
    } catch (e) {
      console.error(e);
    }

    const root = ReactDOM.createRoot(this);
    root.render(<CartMain {...props} />);
  }
};

customElements.define("main-cart", CartMainElem);

// Expose addToCart function to the window object
// so that SearchSpring integration can use it
window.addToCart = async function (id = "", quantity = 1, properties = {}) {
  return addToCart({
    id,
    qty: quantity,
    properties,
  });
};
